import { Spinner } from "@scaffquote/ui";
import { Outlet, ScrollRestoration } from "react-router";
import { NavProgress } from "./components/NavProgress.tsx";
import { UpdatePrompt } from "./components/UpdatePrompt.tsx";

/** Above every route: the loading bar, the update bar and scroll restoration. */
export function RootLayout() {
  return (
    <>
      <NavProgress />
      <UpdatePrompt />
      <Outlet />
      <ScrollRestoration />
    </>
  );
}

/** Shown while the first route's data loads (cold start). */
export function AppLoading() {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <Spinner label="Loading scaffquote" />
    </div>
  );
}
